import {
  Box,
  Typography,
  Container,
  Grid,
  Link,
  IconButton,
  Divider,
} from "@mui/material";
import { LocationOn, Email } from "@mui/icons-material";

// Import social media icons
import instagramIcon from "../../assets/social/instagramBlanco.svg";
import facebookIcon from "../../assets/social/FacebookBlanco.svg";
import tiktokIcon from "../../assets/social/tiktokBlanco.svg";
import youtubeIcon from "../../assets/social/youtube.svg";
import mailIcon from "../../assets/social/threads.svg";

// Import logos and background
import tattersallLogo from "../../assets/TT_VENTA_USADOS.png";
import isoLogo from "../../assets/ISO_9001-2015.svg";
import { CONTACT_INFO, locations } from "../../constants";

const Footer = () => {
  const socialLinks = [
    {
      name: "Instagram",
      url: CONTACT_INFO.social.instagram,
      icon: instagramIcon,
    },
    {
      name: "Facebook",
      url: CONTACT_INFO.social.facebook,
      icon: facebookIcon,
    },
    {
      name: "TikTok",
      url: CONTACT_INFO.social.tiktok,
      icon: tiktokIcon,
    },
    // {
    //   name: "YouTube",
    //   url: "https://www.youtube.com/@tattersallremates",
    //   icon: youtubeIcon,
    // },
    // {
    //   name: "Threads",
    //   url: "https://www.threads.net/@tattersall_remates",
    //   icon: mailIcon,
    // },
  ];

  return (
    <Box
      component="footer"
      sx={{
        // backgroundImage: `url(${fondoFooter})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        backgroundColor: "primary.main",
        color: "white",
        py: 6,
        mt: "auto",
        position: "relative",
        "&::before": {
          content: '""',
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: "rgba(0, 0, 0, 0.3)",
          zIndex: 0,
        },
      }}
    >
      <Container maxWidth="lg" sx={{ position: "relative", zIndex: 1 }}>
        <Grid container spacing={4}>
          {/* Logo and Certification Section */}
          <Grid size={{ xs: 12, md: 4 }}>
            <Box
              sx={{
                textAlign: "center",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <img
                src={tattersallLogo}
                alt="Tattersall Logo"
                title="Logo de Tattersall Remates - Venta de Vehículos, Equipos y Maquinaria Usada"
                style={{
                  height: "auto",
                  marginBottom: "16px",
                }}
              />
            </Box>
            <Box
              sx={{
                justifySelf: "center",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <img
                src={isoLogo}
                alt="ISO 9001-2015 Certification"
                title="Certificación ISO 9001-2015 - Sistema de Gestión de Calidad"
                style={{
                  height: "100px",
                  justifySelf: "center",
                  borderRadius: "10px",
                }}
              />
            </Box>
          </Grid>

          {/* Social Media Section */}
          <Grid size={{ xs: 12, md: 4 }}>
            <Box sx={{ textAlign: "center", mb: 3 }}>
              <Typography variant="h6" sx={{ mb: 0, fontWeight: "bold" }}>
                ENCUÉNTRANOS EN NUESTRAS
              </Typography>
              <Typography variant="h6" sx={{ mb: 3, fontWeight: "bold" }}>
                REDES SOCIALES
              </Typography>
              <Box sx={{ display: "flex", justifyContent: "center", gap: 0 }}>
                {socialLinks.map((social) => (
                  <IconButton
                    key={social.name}
                    component={Link}
                    href={social.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    sx={{
                      // backgroundColor: "rgba(255, 255, 255, 0.1)",
                      "&:hover": {
                        // backgroundColor: "rgba(255, 255, 255, 0.2)",
                        transform: "scale(1.1)",
                      },
                      transition: "all 0.3s ease",
                    }}
                  >
                    <img
                      src={social.icon}
                      alt={social.name}
                      title={`Síguenos en ${social.name} - Tattersall Remates`}
                      style={{ width: "50px", height: "50px" }}
                    />
                  </IconButton>
                ))}
              </Box>
            </Box>
          </Grid>

          {/* Locations Section */}
          <Grid size={{ xs: 12, md: 4 }}>
            <Typography
              variant="h6"
              sx={{ mb: 2, fontWeight: "bold", textAlign: "center" }}
            >
              VITRINA DE EXHIBICIÓN Y VENTAS:
            </Typography>
            <Box sx={{ overflowY: "auto" }}>
              {locations.map((location) => (
                <Box
                  onClick={() => {
                    window.open(`${location.googleRef}`, "_blank");
                  }}
                  key={location.city}
                  sx={{ mb: 2, cursor: "pointer" }}
                >
                  <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
                    <LocationOn sx={{ mr: 1, fontSize: "20px" }} />
                    <Typography variant="body1" sx={{ fontWeight: "bold" }}>
                      {location.city}
                    </Typography>
                  </Box>
                  <Typography variant="body2" sx={{ ml: 3, lineHeight: 1.4 }}>
                    {location.address}
                  </Typography>
                </Box>
              ))}
              <Divider
                sx={{ my: 2, borderColor: "rgba(255, 255, 255, 0.3)" }}
              />
              <Typography
                sx={{ mb: 2, p: 0, fontWeight: "bold", textAlign: "center" }}
              >
                Horario de atención:
              </Typography>
              <Typography
                sx={{
                  textAlign: "center",
                  whiteSpace: "pre-line",
                }}
                variant="body1"
                gutterBottom
              >
                {/* Debería aparecer un texto abajo del otro */}

                {`${CONTACT_INFO.schedule.weekdays}.\n${CONTACT_INFO.schedule.friday}.\n${CONTACT_INFO.schedule.weekend}.`}
              </Typography>
            </Box>
          </Grid>
        </Grid>

        {/* Copyright Section */}
        <Box
          sx={{
            borderTop: "1px solid rgba(255, 255, 255, 0.3)",
            pt: 3,
            mt: 4,
            textAlign: "center",
          }}
        >
          <Typography variant="body2">
            © 2025 Tattersall. Todos los derechos reservados.
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
